import { useState } from 'react';

// Material UI
import { Card, CardContent } from '@mui/material';

// Componentes
import AdminLayout from '@components/MainPage/AdminLayout';
import ActionHeader from '@components/Containers/ActionHeader';
import CustomTabs from '@components/Tabs/CustomTabs';
import ListEstructura from '@components/Foca/ListEstructura';

import middleware from '@middlewares/middleware';

const Estructura = () => {
  const [tab, setTab] = useState(0);

  const permissions = {
    edit: middleware.checkMenuAction('Editar'),
    delete: middleware.checkMenuAction('Eliminar'),
  };

  return (
    <AdminLayout>
      <ActionHeader title="Estructura" />

      <Card className="card-primary">
        <CardContent>
          <CustomTabs
            value={tab}
            setValue={setTab}
            tabs={[
              {
                value: 0,
                label: 'Secretaría de Formación y Capacitación - CDE',
                sxContent: { pt: 0 },
                component: <ListEstructura type={0} permissions={permissions} />,
              },
              {
                value: 1,
                label: 'Capacitadores Nacionales (SCAN)',
                sxContent: { pt: 0 },
                component: <ListEstructura type={1} permissions={permissions} />,
              },
              {
                value: 2,
                label: 'Secretarios Municipales de Formación y Capacitación',
                sxContent: { pt: 0 },
                component: <ListEstructura type={2} permissions={permissions} />,
              },
            ]}
          />
        </CardContent>
      </Card>
    </AdminLayout>
  );
};

export default Estructura;
